export const GITHUB = "https://github.com/context-labs";
export const HIRING = "https://jobs.ashbyhq.com/inference";
export const INFERENCE_CLOUD_TWITTER = "https://x.com/inference_net";
export const INFERENCE_CLOUD_DOCUMENTATION = "https://docs.inference.net";
export const INFERENCE_CLOUD_BATCH_DOCUMENTATION =
  "https://docs.inference.net/features/batch-api";
export const INFERENCE_CLOUD_PRICING = "https://inference.net/pricing";
export const INFERENCE_CLOUD_GITHUB = "https://github.com/context-labs";
export const INFERENCE_CLOUD_LINKEDIN =
  "https://www.linkedin.com/company/inference-net";

export const INFERENCE_NO_REPLY_EMAIL = "no-reply@inference.net";
export const INFERENCE_CLOUD_SUPPORT_EMAIL = "support@inference.net";
export const INFERENCE_CLOUD_ENTERPRISE_EMAIL = "sales@inference.net";
export const INFERENCE_GRANTS_APPLICATION_EMAIL = "grants@inference.net";
